import { apiClient, ApiClientConfig } from "api";
import { axiosInstance } from "api/axios-instance";
import { apiClientV3 } from "api/clientV3";
import { CONFIG } from "config";
import { DropdownCommanParams } from "features/events";
export type CraeteTitleCmsrDTO = {
  title: string,
  is_active: boolean,
}


type DeleteSelectedCustomerRequest = {
  SessionId: string;
  ParticipatnIds: number[];
};

export type DeleteNotificationTemplateDTO = {
  NotificationTemplateId: number,

}

export type CraeteNotificationTemplateDTO = {
  id?:string,
  title?:string,
  titleAr?:string,
  announcementType?:string,
  contentEn?:string,
  contentAr?:string,
  image?:string,
  imageUrl?:string
   
}

export type SendFirebaseNotificatoinDTO = {
  TemplateId:string,
  IsInstant:boolean;
  Title?:string,
  TitleAr?:string,
  AnnouncementTypeId?:string,
  ContentEn?:string,
  ContentAr?:string,
  image?:string,
  imageUrl?:string,
  SessionId?:string,
  ScheduleDateTime?:string;
}

interface MoveSelectedUserData {
  ParticipantId: number;
  EventID: number;
  EventName: string;
  Email: string;
  TicketCategoryId: number;
  FirstName: string;
  LastName: string;
  BookingId: string;
  ParticipantNo: string;
  UserType: string;
  Age: number;
  Gender: string;
  SportCategoryId: number;
  SportCategoryName: string;
  TicketCategoryName: string;
  UserId: number;
  MobileNo: string;
  Nationality: string;
}

export type MoveSelectedCustomerRequest ={
  UserDataList: MoveSelectedUserData[];
  SessionId: string;
}


export const NotificationApiService = () => {

    const replaceSubstring = (
    input: string,
    target: string,
    replacement: string,
  ): string => {
    const startIndex = input.indexOf(target);
    const endIndex = startIndex + target.length;
    const replacedStr =
      input.slice(0, startIndex) + replacement + input.slice(endIndex);

    return replacedStr;
  };


  const getNotificationType = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `/admin/announcement/type`,
      params,
    });

    return response.data;
  };
  // const getNotificationList = async (
  //   params: any,
  //   callConfig?: Partial<ApiClientConfig>,
  // ) => {
  //   const response = await apiClient<any>({
  //     ...callConfig,
  //     endpoint: `/admin/announcement/list`,
  //     params,
  //   });

  //   return response.data;
  // };

   const getNotificationList = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClientV3<any>({
     
      ...callConfig,
      endpoint: `/admin/notification/getnotificationtemplatelist`,
      params,
    });

    return response.data;
  };
 

  const createNotificationType = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClient({
      endpoint: `/admin/announcement/type`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  // const createNotificationList = async (payload: CraeteTitleCmsrDTO) => {
  //   const response = await apiClient({
  //     endpoint: `/admin/announcement/list`,
  //     method: 'POST',
  //     data: payload,
  //   });

  //   return response.data;
  // };
 const createNotificationList = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClientV3({
      endpoint: `/admin/notification/addupdatenotification`,
      method: 'POST',
      data: payload,
    });

    return response.data;
    
    

  };
  

  const updateStatus = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClient({
      endpoint: `/admin/events/updatestatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

const SelectParticatNotification = async (payload: any) => {
    const response = await apiClientV3({
      endpoint: `/admin/notification/savefiltereduserfornotificaition`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const sendNotification = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/admin/senddevicenotification`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
    

    const getNotificationCommonDropDownList = async (params:DropdownCommanParams, callConfig?: Partial<ApiClientConfig>) => {

   const query = new URLSearchParams({
    flag: params.flag,
    searchId: params.searchId.toString(),
    SearchKey: params.SearchKey
  }).toString();
  

    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `/admin/notification/commonnotificationdropdownlist?${query}`,
    
    })

 
    return response.data
  }

  const getNotificationTemplate = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    
    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `admin/notification/getnotificationtemplatelist`,
      params,
    });

    return response.data;

  };

   const createNotificationTemplate = async (payload: CraeteNotificationTemplateDTO) => {
   
        const sportsService = replaceSubstring(
          CONFIG.SUFFIX_API_BASE_URL,
          '/identity/',
          '/events/',
        );
    
        const response = await axiosInstance.post(
          `${sportsService}/v3/admin/notification/createupdatenotificationtemplate`,
          payload,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
    
    return response.data;

  };


   const deleteNotificationTemplate = async (payload: DeleteNotificationTemplateDTO) => {
    const response = await apiClientV3({
      endpoint: `/admin/notification/removenotificationtemplate`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };


  const getNotificationCustomerList = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {

    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `admin/notification/getuserlistfornotifications`,
      params,
    });

    return response.data;

  };


  const moveSelectedUser = async (payload: MoveSelectedCustomerRequest) => {
   
    const response = await apiClientV3({
      endpoint: `/admin/notification/saveselectedusersfornotification`,
      method: 'POST',
      data: payload,
    });

    return response.data;

  };

  const getSelectedCustomerList = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `admin/notification/getselectednotificationrecipient`,
      params,
    });
   
    return response.data;

    
  };

   const deleteSelectedCustomers = async (payload: DeleteSelectedCustomerRequest) => {
    const response = await apiClientV3({
      endpoint: `/admin/notification/removeselectedusers`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  
  const sendFirebaseNotificationTemplate = async (payload: SendFirebaseNotificatoinDTO) => {
   
        const sportsService = replaceSubstring(
          CONFIG.SUFFIX_API_BASE_URL,
          '/identity/',
          '/events/',
        );

        const response = await axiosInstance.post(
          `${sportsService}/v3/admin/notification/savepushnotificationinfo`,
          payload,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
    
    return response.data;
  };

 
  
  const getNotificationList_ = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {

    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `admin/notification/getnotificationlistv3`,
      params,
    });

    return response.data;

  };

    const getNotificationDetailList_ = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    
    const response = await apiClientV3<any>({
      ...callConfig,
      endpoint: `admin/notification/getuserbasedonnotificationid`,
      params,
    });

    return response.data;

  };


  return {
    getNotificationType,
    getNotificationList,
    updateStatus,
    SelectParticatNotification,
    createNotificationType,
    createNotificationList,
    sendNotification,
    getNotificationCommonDropDownList,
    getNotificationTemplate,
    createNotificationTemplate,
    deleteNotificationTemplate,
    getNotificationCustomerList,
    moveSelectedUser,
    getSelectedCustomerList,
    deleteSelectedCustomers,
    sendFirebaseNotificationTemplate,
    getNotificationList_,
    getNotificationDetailList_
  };
};


